/**
 * External dependencies.
 */
import { assign, has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = false ) {
	const { blockAdvanceOptions, gap, blockClientId } = props.attributes;
	const { header, content, border } = blockAdvanceOptions;

	let css = '';
	selector = selector ? selector : `.gutenify-section-${ blockClientId } .gutenify-block-content-toggle-item-wrapper`;

	let styleNormal = '';
	styleNormal += `${ gap ? `margin-bottom: ${ gap };` : '' }`;
	styleNormal += `${ has( border, 'color' ) && ! isEmpty( border.color ) ? `border-color: ${ border.color };` : '' }`;
	styleNormal += `${ has( border, 'width' ) && border.width > 0 ? `border-width: ${ border.width }px;` : '' }`;
	styleNormal += `${ has( border, 'width' ) && border.width > 0 ? `border-style: solid;` : '' }`;
	styleNormal += `${ has( border, 'radius' ) && ! isEmpty( border.radius ) ? `border-radius: ${ border.radius };` : '' }`;

	// Header normal
	if ( styleNormal ) {
		css += `${ selector } { ${ styleNormal } }`;
	}

	styleNormal = '';
	styleNormal += `${ has( header, 'textColor' ) && ! isEmpty( header.textColor ) ? `color: ${ header.textColor };` : '' }`;

	if ( styleNormal ) {
		css += `${ selector } .gutenify-content-toggle-item-header > * { ${ styleNormal } }`;
	}

	styleNormal = '';
	styleNormal += `${ has( header, 'backgroundColor' ) && ! isEmpty( header.backgroundColor ) ? `background: ${ header.backgroundColor };` : '' }`;
	if ( has( header, 'backgroundGradient' ) && ! isEmpty( header.backgroundGradient ) ) {
		styleNormal += `background: ${ header.backgroundGradient };`;
	}

	if ( styleNormal ) {
		css += `${ selector } .gutenify-content-toggle-item-header { ${ styleNormal } }`;
	}

	// Header Hover
	styleNormal = '';
	styleNormal += `${ has( header, 'hoverTextColor' ) && ! isEmpty( header.hoverTextColor ) ? `color: ${ header.hoverTextColor };` : '' }`;

	if ( styleNormal ) {
		css += `${ selector } .gutenify-content-toggle-item-header:hover > * { ${ styleNormal } }`;
	}

	styleNormal = '';
	styleNormal += `${ has( header, 'hoverBackgroundColor' ) && ! isEmpty( header.hoverBackgroundColor ) ? `background: ${ header.hoverBackgroundColor };` : '' }`;
	if ( has( header, 'hoverBackgroundGradient' ) && ! isEmpty( header.hoverBackgroundGradient ) ) {
		styleNormal += `background: ${ header.hoverBackgroundGradient };`;
	}

	if ( styleNormal ) {
		css += `${ selector } .gutenify-content-toggle-item-header:hover { ${ styleNormal } }`;
	}

	// Content Normal
	styleNormal = '';
	styleNormal += `${ has( content, 'textColor' ) && ! isEmpty( content.textColor ) ? `color: ${ content.textColor };` : '' }`;

	if ( styleNormal ) {
		css += `${ selector } .gutenify-content-toggle-item-content > * { ${ styleNormal } }`;
	}

	styleNormal = '';
	styleNormal += `${ has( content, 'backgroundColor' ) && ! isEmpty( content.backgroundColor ) ? `background: ${ content.backgroundColor };` : '' }`;
	if ( has( content, 'backgroundGradient' ) && ! isEmpty( content.backgroundGradient ) ) {
		styleNormal += `background: ${ content.backgroundGradient };`;
	}

	if ( styleNormal ) {
		css += `${ selector } .gutenify-content-toggle-item-content { ${ styleNormal } }`;
	}

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}

export default styling;

